// app/bundles/controllers/commission_calculator_controller.js
import { Controller } from '@hotwired/stimulus';
import { formatPriceForSelectedCurrency } from '../utilities/pricing';

export default class extends Controller {
  static targets = ['price', 'net', 'hostingFee', 'hostingNet'];

  initialize() {
    this.calculate();
    this.calculateHostingFee();
  }

  calculate() {
    const price = parseFloat(this.priceTarget.value) || 0;
    const net = (price * 0.8).toFixed(2);
    this.netTarget.textContent = `Net: ${formatPriceForSelectedCurrency(net)}`;
  }

  calculateHostingFee() {
    const hostingFee = parseFloat(this.hostingFeeTarget.value) || 0;
    const hostingNet = (hostingFee * 0.8).toFixed(2);
    this.hostingNetTarget.textContent = `Net: ${formatPriceForSelectedCurrency(hostingNet)}`;
  }
}
